export const LEVELS = [
  'font-family: sans-serif;',
  'color: white;',
  'font-size: 20px;',
  'text-transform: uppercase;',
  'font-kerning: none;',
  'font-variant-caps: all-small-caps;',
  'font-weight: bold;',
  'font-style: italic;',
  'text-decoration: underline;',
  'letter-spacing: 1px;',
  'word-spacing: 5px;',
  'line-height: 1.5;',
  'text-indent: 20px;',
  'text-align: center;',
  'text-shadow: 1px 1px lightgray;',
  ['overflow: hidden;','white-space: nowrap;','text-overflow: ellipsis;'],
  'direction: rtl;',
  'text-emphasis: triangle;',
  'writing-mode: vertical-lr;',
  'text-orientation: upright;',
];

export const COLORS = [
  '#ff0000',
  '#ff4d00',
  '#ff9900',
  '#ffe600',
  '#ccff00',
  '#33ff00',
  '#80ff00',
  '#00ff19',
  '#00ff66',
  '#00ffb3',
  '#00ffff',
  '#00b2ff',
  '#0066ff',
  '#0019ff',
  '#3300ff',
  '#8000ff',
  '#cc00ff',
  '#ff00e5',
  '#ff0099',
  '#ff004d',
  '#ff0000',
];
